import { rateTypeDisplayLabel } from 'src/utils/rateTypeIdentity';
import { EventAgreementWorkspaceData } from 'src/contracts/companyProfile';
import {
  QuoteRateTypeOption,
  isEnabledAgreementRate
} from '../createQuote/agreementRateTypes';

export interface SavedQuoteRateTypeOption extends QuoteRateTypeOption {
  disabled?: boolean;
}

export const savedQuoteRateTypes = (
  agreement: EventAgreementWorkspaceData | null | undefined
): SavedQuoteRateTypeOption[] => {
  const version = agreement?.effective;
  const policy = version?.clientRatePolicySnapshot ?? version?.clientRuleSetVersion?.config;
  if (!policy) return [];
  return policy.baseRates.map((rate) => ({
    value: rate.code,
    label: rateTypeDisplayLabel(rate.code, rate.label),
    disabled: !isEnabledAgreementRate(rate)
  }));
};
